import { Identite } from './identite';

export class AclRole {

    id: string;
    libelle: string;
    hidden: string;
    employe: string;
    extranet: string;
    parent: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id         = data['id'] ? data['id'] : null;
        this.libelle    = data['libelle'] ? data['libelle'] : null;
        this.hidden     = data['hidden'] ? data['hidden'] : null;
        this.employe    = data['employe'] ? data['employe'] : null;
        this.extranet   = data['extranet'] ? data['extranet'] : null;
        this.parent     = data['parent'] ? data['parent'] : null;
    }

}
